import { useCallback, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
    master_saga,
    add_favorite_masters_saga,
    remove_favorite_masters_saga,
    service_saga,
    city_act_saga
} from "../store/actions/service";
import {
    master_filter_saga
} from "../store/actions/master";
import { get_room_for_client } from "../store/actions/chat";
import getPosition from "../utils/getDistance";
import { useRouter } from "next/router";
import { useState, useRef } from "react";
import authApi from '../services/authinstance';
import keys from '../services/keys';
import { get_posts_slider } from "../store/actions/posts";

const queryString = require('query-string');
const Master = (props) => {
    const [show_map, setMap] = useState(false);
    const [center, setCenter] = useState();
    const [open, setOpen] = useState(!props.currentService);
    const [city_position, setPosition] = useState(null);
    const [my_city, setCity] = useState(null);
    const masters_data = useSelector(state => state.masters);
    const translate = useSelector(state => state.translate);
    const settings = useSelector(state => state.settings);
    const languages = useSelector(state => state.language);
    const posts_slider = useSelector(state => state.postsSlider);
    const closestCities = useSelector(state => state.closestCities);
    const closestMastersPosts = useSelector(state => state.closestMastersPosts);
    const user = useSelector(state => state.getme.data);
    const service_data = useSelector(state => state.service);
    const aa = useSelector((state) => state);
    // const [mapRef, setMapRef] = useState(null);
    const mapRef = useRef();
    const router = useRouter();
    const dispatch = useDispatch();
    const handleClick = (href) => {
        router.push(href);
    };
    const handleClose = useCallback(() => { setOpen(false); }, []);
    const get_room = (user_id) => {
        dispatch(get_room_for_client({
            token: props.token, data: { user_id, is_with_admin: false },
            cb: () => handleClick(`/chats?master=${user_id}`)
        }));
    };

    const category_array = useMemo(() => {
        let categories = [];
        let array = service_data?.data?.results;
        for (let index = 0; index < array?.length; index++) {
            const element = array[index];
            categories = [...categories, ...element.sub_category];
        }
        return categories;
    }, [service_data]);

    const master_saga_act = (data) => {
        const params = queryString.parse(location.search);
        const stringified = queryString.stringify({ ...params, ...data });
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + stringified;
        window.history.pushState({ path: newurl }, '', newurl);
        dispatch(
            master_saga({
                token: props.token,
                params: {
                    ...params,
                    ...data
                }
                // role_code: role_code.value, username: username.value, password: username.value
            })
        );
    };
    const add_favorite_masters = (data) => {
        dispatch(
            add_favorite_masters_saga({
                ...data
                // role_code: role_code.value, username: username.value, password: username.value
            })
        );
    };
    const get_city_by_search = (search) => {
        if (search) dispatch(city_act_saga({ search }));
    };
    const remove_favorite_masters = (data) => {
        dispatch(
            remove_favorite_masters_saga({
                ...data
            })
        );
    };
    var map;
    var maps;
    useEffect(() => {
        if (mapRef.current) {
            maps = mapRef.current.maps;
            map = mapRef.current.map;
        }
    }, [mapRef]);
    // const services_get = async () => {
    //     let services = await authApi.get(`${keys.SERVER_URL}utils/new-category/?limit=1000&offset=`);
    //     let data = services.data;
    //     return services.data;
    // };
    const get_service = useCallback(() => dispatch(
        service_saga({
            token: props.token,
        })
    ), []);

    useEffect(() => {
        if (service_data.loading) {
            get_service();
        }
    }, [service_data.loading]);
    // useEffect(() => {
    //     if (props.lat && props.lng) {
    //         getCity(props.lat, props.lng, props.language, (item) => {
    //             setCity(item);
    //         });
    //     }
    // }, [show_map]);
    useEffect(() => {
        const timer = setTimeout(
            function () {
                setMap(true);
            },
            1000
        );
        return () => clearTimeout(timer)
    }, [])
    useEffect(() => {
        if (props.lat) {
            setCenter({ lat: props.lat, lng: props.lng })
        }
    }, []);
    useEffect(() => {
        if (languages.results && languages.results.length > 0) {
            dispatch(get_posts_slider({
                language: languages.results.filter((el) => el.code === props.language.toUpperCase())[0].id,
                category:props?.currentService?.id,
                web_category:'True'
            }))
        }
    }, [languages.results, props.currentService]);
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js';
        script.async = true;
        document.body.appendChild(script);
        // get_service();
        // get_master_saga()
        if (!props.lat) {
            getPosition((lat, lng) => { setCenter({ lat, lng }) })
        }

        if (props.loggedIn) return; // do nothing if the user is logged in
        router.push("/login");

    }, [props.loggedIn]);
    return {
        masters_data,
        translate,
        settings,
        user,
        mapRef,
        show_map,
        city_position,
        my_city,
        category_array,
        service_data,
        open,
        closestCities,
        closestMastersPosts,
        center,
        posts_slider,
        dispatch,
        handleClose,
        setPosition,
        master_saga_act,
        add_favorite_masters,
        remove_favorite_masters,
        handleClick,
        get_room,
        get_city_by_search
    };
};
export default Master;